// extracted by mini-css-extract-plugin
export default {"fondoOscuro":"TopNavBar_fondoOscuro__Vb4Vk","imagen-blanca":"TopNavBar_imagen-blanca__rhg6L","topNavBar":"TopNavBar_topNavBar__krrx7"};